import React from 'react';

export const additionalInfo = (
  <h3 className="vads-u-font-size--h5">Additional Events</h3>
);
